import {useEffect, useRef} from 'react'
import {withLanguage, withDictionary} from '../../assets/js/contexts'
import Parallax from 'parallax-js'
import './parallax-header.scss'
import config from "../../config";
import {useLang} from "../../helpers/language";
const ParallaxHeader = ({dictionary}) => {
    const scene = useRef(null)
    const {lang} = useLang();
    const initScene = () => {
        new Parallax(scene.current)
    }

    const scrollTo = () => {
        window.scroll({
            top: window.innerHeight - 83,
            left: 0,
            behavior: 'smooth'
        })
    }

    useEffect(() => {
        initScene()
    }, [])

    return (
        <header>
            <div className="container position-relative h-100">
                <div className="row h-100 align-items-center">
                    <div className="col-12">
                        <h1> {
                            config.pages.home.homeTitle.white[lang]
                        }
                            <br/>
                            <span>{
                                config.pages.home.homeTitle.yellow[lang]
                            }</span>
                        </h1>
                    </div>
                </div>
                <div id="scene"
                    ref={scene}>
                    <img src="/static/images/bottle-2.png" data-depth="-0.6" alt=""/>
                    <img src="/static/images/bottle-1.png" data-depth="0.2" alt=""/>
                </div>
                <div className="scroller">
                    <button onClick={scrollTo} aria-label="scroll to">
                        <img src="/static/icons/arrow-white.svg" data-arrow="down" alt=""/>
                    </button>
                </div>
            </div>
        </header>
    )
}

export default withLanguage(withDictionary(ParallaxHeader))
